export const TooltipObjectId = 'TooltipObject';

export enum TooltipObjectAttributes {
  NAME = 'name',
  TEXT = 'text',
}
